/**
 * Dashboard related colors (scoreboard, status chart, leaderboard)
 */
import { palette, createColor } from './palette.colors';

export const scoreBoardColors = {
  cardBorder: createColor(palette.gray.border, palette.dark.techBorder),
  cardBG: createColor(palette.gray.white, palette.dark.content),
  scoreBoardCard: createColor(palette.gray.white, 'transparent'),
  cardTitle: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  cardCount: createColor(palette.blue.onTint, palette.dark.text),
  iconBG: createColor(palette.opacity.black05, palette.dark.cardAlt),
  icon: createColor(palette.blue.darkest, palette.gray.border),
};

export const dashboardColors = {
  shiftCardBorder: createColor(palette.gray.border, palette.gray.border),
  shiftCardBG: createColor(palette.blue.primary, palette.blue.primary),
  tabIconColor: createColor(palette.gray.black, palette.dark.textAlt),
  tabTextColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  tabIconSelectedColor: createColor(palette.blue.primary, palette.blue.primary),
  tabTextSelectedColor: createColor(palette.gray.white, palette.blue.secondary),
  countTextColor: createColor(palette.gray.white, palette.gray.white),
  selectedCountTextColor: createColor(palette.gray.white, palette.gray.white),
  countBG: createColor(palette.gray.charcoal, palette.gray.charcoal),
  selecetdCountBG: createColor(palette.blue.primary, palette.blue.primary),
  disabledOverlay: createColor(palette.opacity.white55, palette.opacity.white80),
  activityIndicator: createColor(palette.ui.activityBlue, palette.ui.activityBlue),
};

export const statusChartColors = {
  statusesText: createColor(palette.gray.textDarker, palette.dark.textLight),
  statusesColors: createColor(palette.blue.dark, palette.blue.dark),
  statusesBorder: createColor(palette.gray.divider, palette.dark.border),
  statusesTotalText: createColor(palette.gray.dark, palette.gray.text),
  statusesSubTotalText: createColor(palette.gray.darkest, palette.gray.white),
  inprogress: createColor(palette.blue.light, palette.blue.light),
  active: createColor(palette.blue.primary, palette.blue.primary),
  awaitingParts: createColor(palette.blue.medium, palette.blue.medium),
  completed: createColor(palette.blue.pale, palette.blue.pale),
};

export const statusPieChartColors = {
  border: createColor(palette.gray.white, palette.gray.card),
  toolTipBG: createColor(palette.gray.white, palette.gray.charcoal),
  toolTipText: createColor(palette.gray.black, palette.gray.white),
  outerBorder: createColor(palette.opacity.black0D, palette.opacity.black0D),
  borderShadow: createColor(palette.special.shadow, palette.special.shadow),
};

export const leaderBoardColors = {
  BG: createColor(palette.gray.white, palette.gray.card),
  title: createColor(palette.gray.field, palette.gray.white),
  border: createColor(palette.gray.divider, palette.dark.borderAlt),
  subTitle: createColor(palette.gray.textSubtle, palette.gray.text),
  cardBG: createColor(palette.opacity.veryLight50, palette.dark.card),
  cardBorder: createColor(palette.gray.border, palette.dark.borderLight),
  cardLeaderName: createColor(palette.gray.darkest, palette.dark.textLight),
  cardSelfLeaderName: createColor(palette.gray.white, palette.gray.white),
  cardSelfLeaderBG: createColor(palette.blue.primary, palette.blue.primary),
  cardLeaderRepairs: createColor(palette.gray.dark, palette.gray.text),
  selectedCard: createColor(palette.gray.almostWhite, palette.dark.cardSelected),
  selectedCardBorder: createColor(palette.gray.almostWhite, palette.dark.borderLight),
  bottomLine: createColor(palette.gray.divider, palette.dark.border),
  bottomText: createColor(palette.gray.darker, palette.gray.darker),
  rankTextColor: createColor(palette.gray.dark, palette.gray.dark),
};

export const leaderRankColors = {
  oneColorBG: createColor(palette.opacity.grayAlpha, palette.opacity.grayAlpha),
  oneColorBorder: createColor(palette.gray.borderLight, palette.gray.borderLight),
  twoColorBG: createColor(palette.opacity.grayAlpha, palette.opacity.grayAlpha),
  twoColorBorder: createColor(palette.gray.borderLight, palette.gray.borderLight),
  threeColorBG: createColor(palette.opacity.grayAlpha, palette.opacity.grayAlpha),
  threeColorBorder: createColor(palette.gray.borderLight, palette.gray.borderLight),
  remainingColorBG: createColor(palette.opacity.gray80, palette.opacity.gray80),
  remainingColorBorder: createColor(palette.gray.borderLight, palette.gray.borderLight),
  remainingColorText: createColor(palette.gray.darker, palette.gray.white),
  fourIconBG: createColor(palette.gray.veryLight, palette.gray.veryLight),
  fourIconBorder: createColor(palette.gray.divider, palette.gray.divider),
};

export const repairBoardColors = {
  cardBorder: createColor(palette.gray.border, palette.dark.techBorder),
};